import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "49",
  height: "48",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.94208 33.7059C4.36328 30.7455 3.51562 27.4164 3.51562 24C3.51562 18.5299 5.68862 13.2839 9.55656 9.41593C13.4245 5.54799 18.6705 3.375 24.1406 3.375C29.6108 3.375 34.8568 5.54799 38.7248 9.41593C42.5927 13.2839 44.7656 18.5299 44.7656 24C44.7656 29.4701 42.5927 34.7162 38.7248 38.5841C34.8568 42.4521 29.6108 44.625 24.1406 44.625C20.7514 44.625 17.448 43.7908 14.5052 42.2359L4.45312 43.6875L5.94208 33.7059Z",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M31.6406 16.5L16.6406 31.5",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M31.6406 31.5L16.6406 16.5",
      stroke: "#454342",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }